/**
 * Auto-generated by `npm run studio -- codegen`. Do not edit by hand.
 * Registers every sheet SkinPack emitted by the animation studio.
 */
import type { SkinPack } from './types';
import { registerSkinPack } from './registry';
import { realmSkinPack } from './realmSkin';

const packs: SkinPack[] = [
  realmSkinPack,
];

for (const pack of packs) {
  registerSkinPack(pack);
}
